/** ---- Dispatch Types ---- */
import { PrescriptionType } from "model/prescription.model";

export const PRESCRIPTIONS_CREATED_T = "PRESCRIPTIONS_CREATE_T";
export const PRESCRIPTIONS_CREATED_START = "PRESCRIPTIONS_CREATED_START";
export const PRESCRIPTIONS_CREATED = "PRESCRIPTIONS_CREATED";
export const PRESCRIPTIONS_CREATED_ERROR = "PRESCRIPTIONS_CREATED_ERROR";
export const PRESCRIPTIONS_CREATED_R = "PRESCRIPTIONS_CREATED_R";
export const PRESCRIPTIONS_CREATED_R_START = "PRESCRIPTIONS_CREATED_R_START";
export const PRESCRIPTIONS_CREATED_R_ERROR = "PRESCRIPTIONS_CREATED_R_ERROR";
export const PRESCRIPTIONS_PDF = "PRESCRIPTIONS_PDF";
export const PRESCRIPTIONS_PDF_START = "PRESCRIPTIONS_PDF_START";

/** ---- Dispatch Interfaces ---- */
interface PrescriptionsPdfCreatedStart {
  type: typeof PRESCRIPTIONS_PDF_START;
}

interface PrescriptionsPdfCreated {
  type: typeof PRESCRIPTIONS_PDF;
  payload: Array<PrescriptionType>;
}

interface PrescriptionsCreatedRecipe {
  type: typeof PRESCRIPTIONS_CREATED_R;
  payload: Array<PrescriptionType>;
}

interface PrescriptionsCreatedRecipeStart {
  type: typeof PRESCRIPTIONS_CREATED_R_START;
  payload: Array<PrescriptionType>;
}

interface PrescriptionsCreatedRecipeError {
  type: typeof PRESCRIPTIONS_CREATED_R_ERROR;
}

interface PrescriptionsCreatedStart {
  type: typeof PRESCRIPTIONS_CREATED_START;
}

interface PrescriptionsCreated {
  type: typeof PRESCRIPTIONS_CREATED;
  payload: Array<PrescriptionType>;
}

interface PrescriptionsCreatedTransient {
  type: typeof PRESCRIPTIONS_CREATED_T;
  payload: Array<PrescriptionType>;
}

interface PrescriptionsCreatedError {
  type: typeof PRESCRIPTIONS_CREATED_ERROR;
}

export type PrescriptionAction =
  | PrescriptionsCreatedTransient
  | PrescriptionsCreatedRecipeStart
  | PrescriptionsCreatedStart
  | PrescriptionsCreated
  | PrescriptionsCreatedError
  | PrescriptionsCreatedRecipe
  | PrescriptionsPdfCreated
  | PrescriptionsPdfCreatedStart
  | PrescriptionsCreatedRecipeError;
